/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CreatePaymentV1Dto } from '../models/CreatePaymentV1Dto';
import type { DeleteManyRequestV1 } from '../models/DeleteManyRequestV1';
import type { DeleteManyResultV1 } from '../models/DeleteManyResultV1';
import type { PatchPaymentV1Dto } from '../models/PatchPaymentV1Dto';
import type { PaymentV1Dto } from '../models/PaymentV1Dto';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class PaymentsService {
  /**
   * @param requestBody
   * @returns PaymentV1Dto create entity
   * @throws ApiError
   */
  public static paymentControllerV1CreateV1(
    requestBody: CreatePaymentV1Dto,
  ): CancelablePromise<PaymentV1Dto> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/v1/payments',
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        400: `Bad Request - Invalid input data or validation failed`,
        401: `Unauthorized - Invalid or missing authentication token`,
      },
    });
  }
  /**
   * @returns PaymentV1Dto a entity list
   * @throws ApiError
   */
  public static paymentControllerV1FindAllV1(): CancelablePromise<Array<PaymentV1Dto>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/v1/payments',
      errors: {
        401: `Unauthorized - Invalid or missing authentication token`,
      },
    });
  }
  /**
   * @param requestBody
   * @returns DeleteManyResultV1 batch delete result
   * @throws ApiError
   */
  public static paymentControllerV1RemoveManyV1(
    requestBody: DeleteManyRequestV1,
  ): CancelablePromise<DeleteManyResultV1> {
    return __request(OpenAPI, {
      method: 'DELETE',
      url: '/v1/payments',
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        400: `Bad Request - Invalid input data or validation failed`,
        401: `Unauthorized - Invalid or missing authentication token`,
      },
    });
  }
  /**
   * @param uuid paymentId
   * @returns PaymentV1Dto the entity
   * @throws ApiError
   */
  public static paymentControllerV1FindOneV1(uuid: string): CancelablePromise<PaymentV1Dto> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/v1/payments/{uuid}',
      path: {
        uuid: uuid,
      },
      errors: {
        400: `Bad Request - Invalid input data or validation failed`,
        401: `Unauthorized - Invalid or missing authentication token`,
        404: `Not Found - Entity with given UUID does not exist`,
      },
    });
  }
  /**
   * @param uuid paymentId
   * @param requestBody
   * @returns PaymentV1Dto the update entity
   * @throws ApiError
   */
  public static paymentControllerV1UpdatePartialV1(
    uuid: string,
    requestBody: PatchPaymentV1Dto,
  ): CancelablePromise<PaymentV1Dto> {
    return __request(OpenAPI, {
      method: 'PATCH',
      url: '/v1/payments/{uuid}',
      path: {
        uuid: uuid,
      },
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        400: `Bad Request - Invalid input data or validation failed`,
        401: `Unauthorized - Invalid or missing authentication token`,
        404: `Not Found - Entity with given UUID does not exist`,
        409: `Conflict - Version mismatch (optimistic locking). Entity was modified by another request.`,
      },
    });
  }
  /**
   * @param uuid paymentId
   * @returns PaymentV1Dto the entity
   * @throws ApiError
   */
  public static paymentControllerV1RemoveOneV1(uuid: string): CancelablePromise<PaymentV1Dto> {
    return __request(OpenAPI, {
      method: 'DELETE',
      url: '/v1/payments/{uuid}',
      path: {
        uuid: uuid,
      },
      errors: {
        400: `Bad Request - Invalid input data or validation failed`,
        401: `Unauthorized - Invalid or missing authentication token`,
        404: `Not Found - Entity with given UUID does not exist`,
      },
    });
  }
}
